import { Form, Select, Button, DatePicker } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import { getButtonDisabled } from "../../../utilities/helpers";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getCompanyTemplates,
  getDetails,
  setPerformanceReport,
}) => {
  const disabledDate = (current) => {
    return current > dayjs().endOf("day");
  };
  return (
    <div className="w-fit px-8 py-6">
      <div className="justify-end flex items-center h-full space-x-5 ">
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            value={get(filter, "company")}
            placeholder="Select Company"
            optionFilterProp="label"
            showSearch
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                templateType: undefined,
                template:undefined,
                company,
              });
              setConfig({
                ...config,
                template_types: get(company, "template_access_list"),
              });
              form.setFieldsValue({
                template_type: undefined,
                template: undefined,
              });
              setPerformanceReport(undefined);
            }}
          />
        </Form.Item>
        <Form.Item
          name="template_type"
          label="Template Type"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Type"
            options={map(get(config, "template_types"), (templateType) => ({
              label: get(templateType, "name"),
              value: get(templateType, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              getCompanyTemplates(value);
              setFilters({
                ...filter,
                templateType: value,
                template:undefined,
              });
                form.setFieldsValue({
                template: undefined,
              });
              setPerformanceReport(undefined);
            }}
          />
        </Form.Item>
        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "id"),
            }))}
            value={get(filter, "template.id")}
            onChange={(value) => {
              setFilters({
                ...filter,
                template: find(get(config, "templates"), ["id", value]),
              });
              setPerformanceReport(undefined);
            }}
          />
        </Form.Item>

        <Form.Item
          initialValue={get(filter, "date")}
          name="date"
          label="Date"
          colon={false}
          layout="vertical"
        >
          <DatePicker
            format={"DD/MM/YYYY"}
            disabledDate={disabledDate}
            onChange={(value, dateString) => {
              setFilters({
                ...filter,
                date: value,
              });
            }}
            value={get(filter, "date")}
          />
        </Form.Item>

        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={getDetails}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "template",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default HeaderSelector;
